/**
 * Configuration object for the DocPro application.
 * @typedef {Object} Config
 * @property {string} appName - The name of the application.
 * @property {string} appVersion - The version of the application.
 * @property {string} appUrl - The URL of the application.
 * @property {string} patientServerUrl - The URL of the patient server.
 * @property {string} apiServerUrl - The URL of the API server.
 * @property {string} notificationServerUrl - The URL of the notification server.
 */

function getEnvironmentConfig() {
  let _AppName = "DocPro";
  let _AppPhone = "(669) 272-3868";
  let _AppEmail = "info@doc.pro";
  let _AppAddress = "New York, United States";
  let _AppUrl = "https://doc.pro";
  let _AppAPIServer = "https://api.aihconweb.com/api/v1";
  // let _AppAPIServer = "http://192.168.0.112:8002/api/v1";

  return {
    _AppName,
    _AppPhone,
    _AppEmail,
    _AppAddress,
    _AppUrl,
    _AppAPIServer
  };
}

export const Config = getEnvironmentConfig();